import './PolicyStyles.css';
import { exportToWord } from '../utils/exportToWord';

const DrugAndAlcoholPolicy = ({
  clientName,
  companyNumber,
  clientAddress,
  effectiveDate,
  safetyOfficerContact,
  hrContact,
}) => {
  const handleExportToWord = () => {
    const policyContent = document.getElementById('policy-content');
    exportToWord(policyContent.innerHTML, "Drug_And_Alcohol_Policy.docx");
  };

  return (
    <div className="policy-container" id="policy-content">
      <h3 className="policy-title">Drug & Alcohol Policy</h3>

      <p className="policy-details"><strong>Company Name:</strong> {clientName || "[Insert Company Name]"}</p>
      <p className="policy-details"><strong>Company Number:</strong> {companyNumber || "[Insert Company Number]"}</p>
      <p className="policy-details"><strong>Company Address:</strong> {clientAddress || "[Insert Company Address]"}</p>
      <p className="policy-details"><strong>Policy Effective Date:</strong> {effectiveDate || "[Insert Effective Date]"}</p>

      <h4 className="section-title">1. Purpose</h4>
      <p className="section-content">
        {clientName || "The Company"} is committed to maintaining a safe, healthy, and productive workplace free from the influence of drugs and alcohol. This policy outlines the company's stance on drug and alcohol use, testing procedures, and disciplinary actions.
      </p>

      <h4 className="section-title">2. Scope</h4>
      <p className="section-content">
        This policy applies to all employees, contractors, and visitors while on company premises or conducting company business, including driving or operating vehicles.
      </p>

      <h4 className="section-title">3. Prohibited Conduct</h4>
      <ul>
        <li>Being under the influence of illegal drugs or alcohol during working hours or on company premises.</li>
        <li>Possession, use, sale, or distribution of illegal drugs or alcohol while on duty or company property.</li>
        <li>Refusal to submit to drug or alcohol testing when requested.</li>
      </ul>

      <h4 className="section-title">4. Drug and Alcohol Testing</h4>
      <p className="section-content">
        {clientName || "The Company"} reserves the right to conduct <strong>random drug and alcohol tests without prior notice</strong> to employees to ensure ongoing compliance and safety. Testing may also be conducted in the following circumstances:
      </p>
      <ul>
        <li>Pre-employment screening.</li>
        <li>Post-incident or accident investigations.</li>
        <li>Reasonable suspicion testing where impairment is suspected.</li>
      </ul>
      <p className="section-content">
        All testing will be carried out in accordance with relevant legislation and best practices, ensuring confidentiality and respect for individuals.
      </p>

      <h4 className="section-title">5. Consequences of Policy Violation</h4>
      <p className="section-content">
        Employees who fail a drug or alcohol test will be <strong>suspended immediately pending a formal interview and investigation</strong>. Based on the findings, further disciplinary action may include retraining, referral to rehabilitation programs, or dismissal.
      </p>
      <p className="section-content">
        Other violations of this policy will be treated seriously and may result in disciplinary action up to and including dismissal. Additional consequences include:
      </p>
      <ul>
        <li>Referral to counselling or rehabilitation programs.</li>
        <li>Temporary suspension pending investigation.</li>
        <li>Legal action if company property or safety is compromised.</li>
      </ul>

      <h4 className="section-title">6. Support and Rehabilitation</h4>
      <p className="section-content">
        {clientName || "The Company"} encourages employees facing substance abuse issues to seek help confidentially. Support may include:
      </p>
      <ul>
        <li>Access to Employee Assistance Programs (EAP).</li>
        <li>Referral to medical and counselling services.</li>
        <li>Reasonable adjustments during rehabilitation.</li>
      </ul>

      <h4 className="section-title">7. Responsibilities</h4>
      <p className="section-content"><strong>Employees:</strong> Must comply with this policy and report any concerns about drug or alcohol misuse.</p>
      <p className="section-content"><strong>Managers and Supervisors:</strong> Responsible for recognising signs of impairment and taking appropriate action.</p>
      <p className="section-content"><strong>Safety Officer:</strong> Oversees implementation of testing and provides guidance on safety-related issues.</p>

      <h4 className="section-title">8. Confidentiality</h4>
      <p className="section-content">
        All information relating to drug and alcohol testing and treatment will be handled confidentially and in compliance with data protection laws.
      </p>

      <h4 className="section-title">9. Review of Policy</h4>
      <p className="section-content">
        This policy will be reviewed annually or as required by changes in legislation or company circumstances.
      </p>

      <h4 className="section-title">Contact Information</h4>
      <ul>
        <li><strong>Safety Officer:</strong> {safetyOfficerContact || "[Insert Contact Number]"}</li>
        <li><strong>Human Resources:</strong> {hrContact || "[Insert Contact Number]"}</li>
      </ul>

      <h4 className="section-title">Employee Acknowledgment and Signature</h4>
      <p>I acknowledge that I have read and understood the Drug & Alcohol Policy and agree to abide by its terms.</p>
      <p>Employee Name: _________________________</p>
      <p>Employee Signature: _________________________</p>
      <p>Date: _________________________</p>

      <h4 className="section-title">Management Approval and Signature</h4>
      <p>This policy has been approved by senior management and is now in effect.</p>
      <p>Manager/Officer Name: _________________________</p>
      <p>Title: _________________________</p>
      <p>Signature: _________________________</p>
      <p>Date: _________________________</p>

      <div className="mt-4 text-center">
        <button
          onClick={handleExportToWord}
          className="bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition"
        >
          Export to Word
        </button>
      </div>
    </div>
  );
};

export default DrugAndAlcoholPolicy;
